export default __webpack_public_path__ + "static/media/windax_2.db98a29c.jpg";